<template>
  <div class="mb-8">
    <div class="-mb-3 flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>
    <div class="my-3 flex w-full flex-col items-start">
      <label
        class="w-full text-left text-xxs font-bold uppercase text-gray-over-dark"
        >{{ question.description }}
        <div class="relative mt-1 w-full">
          <input
            v-model="date"
            type="date"
            class="w-full rounded border border-transparent bg-off-white p-4 text-sm text-dark-gray hover:border-placeholder-gray focus:bg-white"
            placeholder="Lorem Ipsum"
            @input="handleChange"
          />
          <span @click="toggleDatePicker">
            <img
              src="@/assets/calendar.svg"
              class="absolute right-4 top-4"
            />
          </span>
          <date-picker
            v-if="showDatePicker"
            class="date-picker"
            :initial-date="date ? date : undefined"
            :handle-input="handleInput"
          />
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';

export default {
  name: 'Date',
  components: {
    DatePicker,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      date: '',
      showDatePicker: false,
    };
  },
  computed: {
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.date = recentAnswer?.date_value;
  //     this.handleAutoInput()
  //   }
  // },
  watch: {
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.date = recentAnswer?.date_value;
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleInput(date) {
      this.date = date;
      let body = {
        company_question_id: this.question_id,
        date_value: date,
      };
      if (this.required) {
        this.date
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.setOnboardingPacket(body);
      this.toggleDatePicker();
      this.emitForComparison(date);
    },
    toggleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
    },
    closeDatePicker() {
      this.showDatePicker = false;
    },
    handleChange() {
      let body = {
        company_question_id: this.question_id,
        date_value: this.date,
      };
      if (this.required) {
        this.date
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.setOnboardingPacket(body);
      this.closeDatePicker();
      this.emitForComparison(this.date);
    },
    handleAutoInput() {
      let body = null;
      if (this.date) {
        body = {
          company_question_id: this.question_id,
          date_value: this.date,
        };
      }
      if (this.required) {
        this.date
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.setOnboardingPacket(body);
      this.emitForComparison(this.date);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
<style scoped>
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
.date-picker {
  border-radius: 5px;
  box-shadow: 0px 5px 10px rgba(109, 113, 129, 0.14);
  @apply absolute right-0 top-10 z-20 border border-light-gray bg-white p-4 pt-0;
  top: 64px;
}
</style>
